module.exports = __webpack_public_path__ + "static/media/cold_wave.f9e1da7c.png";